// ADMIN AUTH
export const LOGIN_ADMIN = "/auth/login";
export const ADMIN_FORGOT_PASSWORD = "/auth/forgot-password";
export const RESET_PASSWORD = "/auth/reset-password";

//Warranties
export const WARRANTY_LIST = "/warranty/list";
export const WARRANTY_UPDATE_STATUS = "/warranty/update-status";
export const WARRANTY_DETAILS = "/warranty/details";
export const UPDATE_WARRANTY_API_URL = "/warranty/update-customer";
export const WARRANTY_APPROVE = "/warranty/total-sqft";

// QR Codes
export const QR_CODES_LIST = "/qr-code/list";
export const QR_CODES_PRINT = "/qr-code/printqr";
export const QR_CODES_GENERATE = "/qr-code";
export const BULK_PRINT = "/qr-code/bulk-print";
export const EXCEL_UPLOAD = "/qr-code/upload-sheet";
